// extracted by mini-css-extract-plugin
export default {"FileIcon":"KbszzjQC"};